/** Partneri — hemija, omekšivači i programi pranja (lako za izmenu) */
export const PARTNER_STRIP = {
  overline: "Tehnologija pranja",
  title: "Profesionalna hemija vodećih proizvođača",
  lead:
    "Za belinu, mekoću i higijenu tekstila koristimo proverene industrijske programe — omekšivače, deterdžente i sredstva za pranje namenjena ugostiteljstvu i profesionalnim perionicama.",
};

export const partners = [
  {
    id: "diversey",
    name: "Diversey",
    role: "Programi pranja i dezinfekcije",
    logo: "/partners/diversey.svg",
  },
  {
    id: "ecolab",
    name: "Ecolab",
    role: "Industrijska hemija za tekstil",
    logo: "/partners/ecolab.svg",
  },
  {
    id: "henkel",
    name: "Henkel Professional",
    role: "Deterdženti i omekšivači",
    logo: "/partners/henkel.svg",
  },
  {
    id: "christeyns",
    name: "Christeyns",
    role: "Profesionalna nega tkanina",
    logo: "/partners/christeyns.svg",
  },
];

export const DIFFERENTIATORS = [
  "Industrijski kapacitet u Beogradu",
  "Profesionalna hemija i omekšivači",
  "Besplatna procena obima",
  "Fiksni raspored dostave",
  "Jasan mesečni B2B obračun",
  "Bez skrivenih troškova",
];

export const SEO_KEYWORDS = [
  "profesionalno pranje veša Beograd",
  "perionica za hotele Beograd",
  "pranje posteljine hotel",
  "pranje stolnjaka restoran",
  "B2B perionica ugostiteljstvo",
  "TOP WASH DOO",
  "pranje uniformi restoran",
  "pranje peškira spa",
  "industrijsko pranje tekstila",
  "servis pranja veša za biznis",
  "pranje jorgana hotel",
  "rotacija posteljine Beograd",
  "profesionalni omekšivač za veš",
  "perionica Rakovica",
];
